<script lang="ts">
  import type { Snippet } from 'svelte'
  import { t } from '../../lib/i18n/index.svelte.js'
  import IconButton from './IconButton.svelte'

  interface Props {
    open: boolean
    title: string
    onclose: () => void
    children: Snippet
  }
  const { open, title, onclose, children }: Props = $props()

  let dialog = $state<HTMLDialogElement | null>(null)

  // A native dialog gives us the focus trap, Esc and inert background for free.
  $effect(() => {
    if (!dialog) return
    if (open && !dialog.open) dialog.showModal()
    else if (!open && dialog.open) dialog.close()
  })
</script>

<dialog bind:this={dialog} oncancel={(e) => { e.preventDefault(); onclose() }} onclose={onclose}>
  <div class="head">
    <h2>{title}</h2>
    <IconButton icon="close" label={t('close')} onclick={onclose} />
  </div>
  <div class="body">
    {@render children()}
  </div>
</dialog>

<style>
  dialog {
    width: min(520px, 100%);
    max-height: 85dvh;
    margin: auto auto 0;
    padding: 0;
    border: none;
    border-radius: var(--radius-lg) var(--radius-lg) 0 0;
    background: var(--surface);
    color: var(--fg);
    box-shadow: var(--shadow-2);
    overflow: hidden;
  }
  dialog::backdrop {
    background: rgb(0 0 0 / 45%);
    backdrop-filter: blur(2px);
  }
  dialog[open] {
    animation: rise var(--dur) var(--ease);
  }
  @keyframes rise {
    from {
      transform: translateY(16px);
      opacity: 0;
    }
  }
  .head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--space-3);
    padding: var(--space-3) var(--space-3) var(--space-3) var(--space-4);
    border-bottom: 1px solid var(--border);
  }
  h2 {
    font-size: 17px;
    font-weight: 650;
  }
  .body {
    padding: var(--space-4);
    padding-bottom: calc(var(--space-4) + env(safe-area-inset-bottom));
    overflow-y: auto;
    max-height: calc(85dvh - 60px);
  }
  @media (min-width: 640px) {
    dialog {
      margin: auto;
      border-radius: var(--radius-lg);
    }
  }
</style>
